import { Avatar, Skeleton, Stack, Text } from 'native-base';
import { useState } from 'react';
import { BrandedBackground } from 'ui/components/BrandedBackground';
import { getNameInitials } from 'ui/utils/getNameInititals';

import { colors } from '../../theme/colors';
import { SignUpBrandingProps } from './types';

export const SignUpBranding = ({
  brandColor = colors.gray[900],
  logo,
  ecosystemName,
  backgroundImage,
  organizationName = '',
  height = '100vh',
  isBigHelpOutBranded = false,
}: SignUpBrandingProps) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <Stack
      width="100%"
      backgroundColor={isLoading ? 'none' : brandColor}
      minH="100%"
      height="100%"
    >
      <Stack display={isLoading ? 'flex' : 'none'} width="100%" height={height}>
        <Skeleton width="100%" height="100%" />
      </Stack>
      <BrandedBackground
        isLoading={isLoading}
        onLoaded={() => setIsLoading(false)}
        height={height}
        backgroundImage={backgroundImage}
        isBigHelpOutBranded={isBigHelpOutBranded}
      />
      <Stack padding={12} position="absolute" top={0} space={8}>
        <Avatar
          source={{ uri: logo }}
          width={{ base: 100, lg: 125 }}
          height={{ base: 100, lg: 125 }}
        >
          {getNameInitials(organizationName)}
        </Avatar>
        <Stack space={2}>
          <Text
            color="white"
            fontWeight={500}
            fontSize={{ base: '2xl', lg: '3xl' }}
          >
            Welcome to
          </Text>
          <Text
            color="white"
            fontWeight={700}
            fontSize={{ base: '3xl', lg: '5xl' }}
          >
            {ecosystemName}
          </Text>
          <Text
            color="white"
            fontWeight={500}
            fontSize={{ base: '2xl', lg: '3xl' }}
          >
            by {organizationName}
          </Text>
        </Stack>
      </Stack>
    </Stack>
  );
};
